import { useInView } from 'react-intersection-observer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const WildlifePhotoCard = ({ image, caption, slideDirection }) => {
    const { ref, inView } = useInView({
        triggerOnce: false,
        threshold: 0.3,
    });

    const translateXValue = slideDirection === 'left' ? '-100px' : '100px';

    return (
        <Box
            ref={ref}
            sx={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateX(0)' : `translateX(${translateXValue})`,
                transition: 'all 0.8s ease-out',
                textAlign: 'center',
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
                margin: '0 auto',
            }}
        >
            <Box
                component="img"
                src={image}
                alt={caption}
                sx={{
                    width: '100%',
                    maxWidth: '100%',
                    height: 'auto',
                    display: 'block',
                    borderRadius: 2,
                    border: '1px solid #333',
                }}
            />
            <Typography variant="body2" sx={{ color: '#B0BEC5', fontStyle: 'italic', mt: 1.5 }}>
                {caption}
            </Typography>
        </Box>
    );
};

export default WildlifePhotoCard;
